var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserDetailsAdministrationGroupsWithRoles',{attrs:{"is-loading":_vm.isLoading},on:{"onPageChanged":_vm.onGroupPageChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }